export default __webpack_public_path__ + "static/media/testimonial-user-2.61496036.svg";